import { render, staticRenderFns } from "./ModalComprovanteVotacao.vue?vue&type=template&id=5d2675a0"
import script from "./ModalComprovanteVotacao.vue?vue&type=script&lang=js"
export * from "./ModalComprovanteVotacao.vue?vue&type=script&lang=js"
import style0 from "./ModalComprovanteVotacao.vue?vue&type=style&index=0&id=5d2675a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports